import React, { useState } from 'react';
import { logoutUser } from '../firebase';
import { LogoFull, LogoIcon } from './Logo';

const NAV_GROUPS = [
  {
    title: 'Main',
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: '🏠' },
      { id: 'invoices', label: 'Invoices', icon: '📄' },
      { id: 'parties', label: 'Customers & Suppliers', icon: '👥' },
      { id: 'expenses', label: 'Expenses', icon: '🧾' },
    ],
  },
  {
    title: 'Accounting Books',
    items: [
      { id: 'receipts', label: 'Receipts (money in)', icon: '💰' },
      { id: 'payments', label: 'Payments (money out)', icon: '💸' },
      { id: 'pettycash', label: 'Petty Cash', icon: '💵' },
      { id: 'cashbook', label: 'Cash Book', icon: '📓' },
      { id: 'bankbook', label: 'Bank Book', icon: '🏦' },
      { id: 'receivables', label: 'Receivables', icon: '📥' },
      { id: 'payables', label: 'Payables', icon: '📤' },
      { id: 'ledgers', label: 'Ledger Master', icon: '📒' },
      { id: 'voucher', label: 'Voucher & Day Book', icon: '✍️' },
      { id: 'aging', label: 'Aging Report', icon: '⏱️' },
    ],
  },
  {
    title: 'Financial Reports',
    items: [
      { id: 'profitloss', label: 'Profit & Loss', icon: '📈' },
      { id: 'balancesheet', label: 'Balance Sheet', icon: '⚖️' },
      { id: 'trialbalance', label: 'Trial Balance', icon: '🧮' },
      { id: 'reports', label: 'Analytics', icon: '📊' },
      { id: 'dailysales', label: 'Daily Sales Report', icon: '🧾' },
    ],
  },
  {
    title: 'Tools & Setup',
    items: [
      { id: 'bulkupload', label: 'Upload / Import', icon: '⬆️' },
      { id: 'backup', label: 'Backup & Export', icon: '💾' },
      { id: 'settings', label: 'Company Settings', icon: '⚙️' },
    ],
  },
  {
    title: 'Help',
    items: [
      { id: 'contact', label: 'Contact us', icon: '💬' },
    ],
  },
];

const ALL_ITEMS = NAV_GROUPS.flatMap(g => g.items);

export default function Layout({ children, page, setPage, user }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const handleLogout = async () => { await logoutUser(); window.location.reload(); };

  return (
    <div style={{ display:'flex', height:'100vh', overflow:'hidden' }}>
      <div style={{ width: sidebarOpen ? 248 : 68, background:'#0a3d2e', display:'flex', flexDirection:'column', transition:'width 0.2s', flexShrink:0 }}>

        <div style={{ padding: sidebarOpen ? '20px 16px' : '16px 12px', borderBottom:'1px solid rgba(255,255,255,0.07)', display:'flex', alignItems:'center', justifyContent: sidebarOpen ? 'flex-start' : 'center' }}>
          {sidebarOpen ? <LogoFull dark size="sm" /> : <LogoIcon size={36} />}
        </div>

        <nav style={{ flex:1, padding:'8px 0', overflowY:'auto' }}>
          {NAV_GROUPS.map(group => (
            <div key={group.title} style={{ marginBottom: 8 }}>
              {sidebarOpen && (
                <div style={{ padding: '8px 16px 4px', fontSize: 10, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600 }}>{group.title}</div>
              )}
              {group.items.map(n => (
                <button key={n.id} onClick={() => setPage(n.id)} style={{
                  width:'100%', display:'flex', alignItems:'center', gap:10,
                  padding: sidebarOpen ? '9px 16px' : '11px 0',
                  justifyContent: sidebarOpen ? 'flex-start' : 'center',
                  background: page === n.id ? 'rgba(255,255,255,0.1)' : 'transparent',
                  border:'none', color: page === n.id ? '#fff' : 'rgba(255,255,255,0.5)',
                  fontSize:13.5, fontWeight: page === n.id ? 600 : 400,
                  cursor:'pointer',
                  borderLeft: page === n.id ? '3px solid #1d9e75' : '3px solid transparent',
                  transition:'all 0.15s'
                }}>
                  <span style={{ fontSize:16, flexShrink:0 }}>{n.icon}</span>
                  {sidebarOpen && <span>{n.label}</span>}
                </button>
              ))}
            </div>
          ))}
        </nav>

        <div style={{ padding:'10px 0', borderTop:'1px solid rgba(255,255,255,0.07)' }}>
          {sidebarOpen && (
            <div style={{ padding:'8px 16px 4px', fontSize:10, color:'rgba(255,255,255,0.25)', lineHeight:1.8 }}>
              info@finlybooks.com<br/>www.finlybooks.com
            </div>
          )}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ width:'100%', padding:'9px 16px', background:'transparent', border:'none', color:'rgba(255,255,255,0.35)', fontSize:12, cursor:'pointer', display:'flex', alignItems:'center', justifyContent: sidebarOpen ? 'flex-start' : 'center', gap:8 }}>
            <span style={{ fontSize:14 }}>{sidebarOpen ? '◀' : '▶'}</span>
            {sidebarOpen && <span>Collapse</span>}
          </button>
          <button onClick={handleLogout} style={{ width:'100%', padding:'9px 16px', background:'transparent', border:'none', color:'rgba(255,255,255,0.35)', fontSize:12, cursor:'pointer', display:'flex', alignItems:'center', justifyContent: sidebarOpen ? 'flex-start' : 'center', gap:8 }}>
            <span style={{ fontSize:14 }}>🚪</span>
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </div>

      <div style={{ flex:1, display:'flex', flexDirection:'column', overflow:'hidden' }}>
        <div style={{ background:'#fff', borderBottom:'1px solid #f0f0f0', padding:'0 24px', height:56, display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
          <div style={{ fontSize:17, fontWeight:600, color:'#222' }}>
            {ALL_ITEMS.find(n => n.id === page)?.label || 'FinlyBooks'}
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ width:32, height:32, borderRadius:'50%', background:'#e1f5ee', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:'#0f6e56' }}>
              {(user?.email || 'U')[0].toUpperCase()}
            </div>
            <div style={{ fontSize:13, color:'#888' }}>{user?.email}</div>
          </div>
        </div>
        <div style={{ flex:1, overflow:'auto', padding:24, background:'#f7f8fa' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
